import React, { useRef, useEffect } from 'react';

var usePrevious = function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    // happens after return
    ref.current = value;
  }, [value]);
  return ref.current;
};

var useUpdate = function useUpdate(update, value) {
  var previousValue = usePrevious(value);
  return update ? value : previousValue;
};

export var AddonPanel = function AddonPanel(_ref) {
  var active = _ref.active,
      children = _ref.children;
  return (
    /*#__PURE__*/
    // the transform is to prevent a bug where the content would be invisible
    // the hidden attribute is an valid html element that's both accessible and works to visually hide content
    React.createElement("div", {
      hidden: !active,
      style: {
        transform: 'translateX(0px)'
      }
    }, useUpdate(active, children))
  );
};
AddonPanel.displayName = "AddonPanel";